import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Package, Pin, Clock, Calendar, Star } from "lucide-react";

export const PinProductDialog = ({ 
  open, 
  onOpenChange, 
  product, 
  pinDuration, 
  setPinDuration, 
  onPinProduct 
}) => {
  const pinOptions = [
    { value: "permanent", label: "Permanent", icon: <Star className="w-4 h-4" /> },
    { value: "1h", label: "1 Hour", icon: <Clock className="w-4 h-4" /> },
    { value: "24h", label: "24 Hours", icon: <Clock className="w-4 h-4" /> },
    { value: "7d", label: "7 Days", icon: <Calendar className="w-4 h-4" /> },
  ];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0A0A0A] border-white/10 text-white">
        <DialogHeader>
          <DialogTitle className="font-['Unbounded'] flex items-center gap-2">
            <Pin className="w-5 h-5 text-yellow-500" />
            Pin to Top
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          {product && (
            <div className="p-3 bg-white/5 rounded-lg flex items-center gap-3">
              {product.photos?.[0] ? (
                <img src={product.photos[0]} alt="" className="w-12 h-12 rounded object-cover" />
              ) : (
                <div className="w-12 h-12 bg-white/10 rounded flex items-center justify-center">
                  <Package className="w-6 h-6 text-[#64748B]" />
                </div>
              )}
              <div>
                <p className="text-white font-medium">{product.name}</p>
                <p className="text-sm text-[#94A3B8]">{product.price} NOK</p>
              </div>
            </div>
          )}
          
          <div>
            <label className="text-sm text-[#94A3B8] mb-2 block">Pin Duration</label>
            <div className="grid grid-cols-2 gap-2">
              {pinOptions.map(option => (
                <Button
                  key={option.value}
                  variant={pinDuration === option.value ? "default" : "outline"}
                  onClick={() => setPinDuration(option.value)}
                  className={`${pinDuration === option.value ? "bg-yellow-500 text-black" : "border-white/20"} justify-start`}
                >
                  {option.icon}
                  <span className="ml-2">{option.label}</span>
                </Button>
              ))}
            </div>
          </div>
          
          <div className="p-3 bg-yellow-500/10 border border-yellow-500/30 rounded-lg">
            <p className="text-sm text-yellow-400">
              <Pin className="w-4 h-4 inline mr-1" />
              Pinned products will appear at the top of the webshop, before discounted items.
            </p>
          </div>
          
          <Button
            onClick={onPinProduct}
            className="w-full bg-yellow-500 text-black hover:bg-yellow-600 font-bold"
          >
            <Pin className="w-4 h-4 mr-2" />
            Pin to Top
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
